export const languageData = [
  {
    language: "hindi",
    id: 1,
    data: "i love hindi",
  },
  {
    language: "english",
    id: 2,
    data: "i love english",
  },
  {
    language: "french",
    id: 3,
    data: "i love french",
  },
  {
    language: "french2",
    id: 4,
    data: "i love french2",
  },
];
